import React from 'react';

import {useCharacter} from '../character-context';
import {NOTE_SECTIONS, NoteSection} from '../model/character-state';
import {StringListEditor} from './string-list-editor';

import css from './sheet.module.css';

const SECTION_TITLES: Record<NoteSection, string> = {
	organizations: 'Организации',
	allies: 'Союзники',
	enemies: 'Враги',
	backstory: 'Предыстория',
	other: 'Другое',
};

export const NotesTab: React.FC = () => {
	const {state, update} = useCharacter();

	const setSection = (section: NoteSection, values: string[]) =>
		update((current) => ({notes: {...current.notes, [section]: values}}));

	return (
		<>
			{NOTE_SECTIONS.map((section) => (
				<section key={section} className={css.tabSection}>
					<h3 className={css.groupTitle}>{SECTION_TITLES[section]}</h3>
					<StringListEditor
						values={state.notes[section] || []}
						onChange={(values) => setSection(section, values)}
					/>
				</section>
			))}
		</>
	);
};
